export function buildUrlWithParams(url, params) {
  const urlObj = new URL(url);
  Object.entries(params).forEach(_ref => {
    let [key, value] = _ref;
    value && urlObj.searchParams.set(key, value);
  });
  return urlObj.toString();
}
export function createSafeFileUrl(file) {
  try {
    return URL.createObjectURL(file);
  } catch {
    return undefined;
  }
}
//# sourceMappingURL=urls.js.map